import {
  Component,
  Input,
  ViewChildren,
  QueryList,
  ElementRef,
  ChangeDetectorRef,
  ViewChild,
  OnInit,
  OnDestroy,
  HostListener,
  AfterViewInit,
} from "@angular/core";
import {
  GradingStagingData,
  GradingInput,
} from "../../../models/grading.model";
import { ValidationTypes } from "../../../models/meta-data.model";
import { ViewableImageWebPackge } from "../../../models/viewable-image.model";
import * as _ from "underscore";

@Component({
  selector: "lowy-viewable-image",
  templateUrl: "./viewable-image.component.html",
  styleUrls: ["./viewable-image.component.scss"],
  providers: [],
})
export class ViewableImageComponent implements AfterViewInit {
  @Input() id: string;
  @Input() disabled: boolean;

  visible: boolean;
  isOpen: boolean;

  private canvas;

  public viewableImages: ViewableImageWebPackge;
  public octIndex: number;

  @ViewChildren("leftPane") leftPane: QueryList<ElementRef>;
  @ViewChildren("irCanvas") irCanvas: QueryList<ElementRef>;

  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener("mousewheel", ["$event"])
  onMousewheel(event) {
    if (event.deltaY > 0) {
      this.gotoNextOct();
    } else {
      this.gotoPreviousOct();
    }
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event && event.key === "ArrowDown") {
      this.gotoNextOct();
    } else if (event && event.key === "ArrowUp") {
      this.gotoPreviousOct();
    } else if (event && event.key === "Escape") {
      this.close();
    }
  }

  @HostListener("window:resize", ["$event"]) onResize(event) {
    this.drawCanvas();
  }

  private gotoPreviousOct() {
    if (this.viewableImages.octStack[this.octIndex + 1]) {
      this.octIndex++;
      this.drawCanvas();
    }
  }
  private gotoNextOct() {
    if (this.octIndex > 1) {
      this.octIndex--;
      this.drawCanvas();
    }
  }

  ngAfterViewInit() {
    this.irCanvas.changes.subscribe((canvases: QueryList<ElementRef>) => {
      if (canvases && canvases.last) {
        this.canvas = canvases.last.nativeElement;
        this.drawCanvas();
      }
    });
  }

  private drawCanvas() {
    const canvas = this.canvas;
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext("2d");
    const leftPane = this.leftPane.last.nativeElement;

    if (canvas && this.octIndex) {
      // draw background image
      var background = new Image();
      background.src = this.viewableImages.irImageUrl;

      // Make sure the image is loaded first otherwise nothing will draw.
      background.onload = () => {
        const leftPane = this.leftPane.last.nativeElement;
        canvas.width = leftPane.offsetWidth;
        canvas.height = leftPane.offsetHeight;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // let scale = Math.min(canvas.width / background.width, canvas.height / background.height);
        let scaleX = canvas.width / background.width;
        let scaleY = canvas.height / background.height;
        let width = background.width * scaleX;
        let height = background.height * scaleY;
        let x = canvas.width / 2 - width / 2;
        let y = canvas.height / 2 - height / 2;
        ctx.drawImage(background, x, y, width, height);

        // draw lines
        let idx;
        for (idx in this.viewableImages.octStack) {
          const x1 = scaleX * this.viewableImages.octStack[idx].x1;
          const x2 = scaleX * this.viewableImages.octStack[idx].x2;
          const y1 = scaleY * this.viewableImages.octStack[idx].y1;
          const y2 = scaleY * this.viewableImages.octStack[idx].y2;
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          // highlight active line
          if (this.octIndex + "" === idx) {
            ctx.strokeStyle = "#00FF00";
          } else {
            ctx.strokeStyle = "#000000";
            ctx.lineWidth = 1;
          }
          ctx.stroke();
          ctx.closePath();
        }
      };
    }
  }

  public open(viewableImages: ViewableImageWebPackge) {
    this.viewableImages = viewableImages;
    this.octIndex = 1;

    this.visible = true;
    setTimeout(() => {
      this.isOpen = true;
    });
  }

  public close(e?) {
    this.octIndex = null;
    if (this.isOpen) {
      this.isOpen = false;
      this.visible = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/viewable-image/viewable-image.component.ts